import {
    OwnerBillingComplianceAnalyticsResponseDto,
    OwnerComplianceAnalyticsMonthDto,
    OwnerComplianceCombinedCurrentResponseDto,
    OwnerParticipantComplianceAnalyticsResponseDto,
    OwnerPerformanceRoleDto,
    OwnerEmployeePerformancePagedResponseDto
} from "../../interfaces";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { apiGet } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";

export async function GetCombinedComplianceCurrentAsync(
    authToken: string,
    regionId?: number | null,
    waiverId?: number | null,
): Promise<ApiResponse<OwnerComplianceCombinedCurrentResponseDto>> {

    const query = buildQuery({
        regionId,
        waiverId,
    });

    const apiUrl =
        `/owner/metrics/compliance/current` +
        (query ? `?${query}` : "");

    var res = apiGet<ApiResponse<OwnerComplianceCombinedCurrentResponseDto>>(
        apiUrl, authToken)

    return res;
}


export async function GetParticipantAnalyticsAsync(
    authToken: string,
    regionId?: number | null,
    waiverId?: number | null,
): Promise<ApiResponse<OwnerParticipantComplianceAnalyticsResponseDto>> {
      const query = buildQuery({
        regionId,
        waiverId,
    });
    const apiUrl: string = `/owner/metrics/compliance/analytics/participants`+
        (query ? `?${query}` : "");

    var res = apiGet<ApiResponse<OwnerParticipantComplianceAnalyticsResponseDto>>(
        apiUrl, authToken)

    return res;
}

export async function GetTaskAnalyticsAsync(
    authToken: string,
    regionId?: number | null,
    waiverId?: number | null,
): Promise<ApiResponse<OwnerComplianceAnalyticsMonthDto[]>> {
      const query = buildQuery({
        regionId,
        waiverId,
    });
    const apiUrl: string = `/owner/metrics/compliance/analytics/task`+
        (query ? `?${query}` : "");

    var res = apiGet<ApiResponse<OwnerComplianceAnalyticsMonthDto[]>>(
        apiUrl, authToken)

    return res;
}

export async function GetBillingAnalyticsAsync(
    authToken: string,
    regionId?: number | null,
    waiverId?: number | null,
): Promise<ApiResponse<OwnerBillingComplianceAnalyticsResponseDto>> {
      const query = buildQuery({
        regionId,
        waiverId,
    });
    const apiUrl: string = `/owner/metrics/compliance/analytics/billing`+
        (query ? `?${query}` : "");

    var res = apiGet<ApiResponse<OwnerBillingComplianceAnalyticsResponseDto>>(
        apiUrl, authToken)

    return res;
}

export async function GetPerformanceEmployeeRolesAsync(
    authToken: string,
): Promise<ApiResponse<OwnerPerformanceRoleDto[]>> {
    const apiUrl: string = `/owner/metrics/performance/employee/roles`;

    var res = apiGet<ApiResponse<OwnerPerformanceRoleDto[]>>(
        apiUrl, authToken)

    return res;
}

export async function GetPerformanceEmployeeCurrentAsync(
    authToken: string,
    role: string,
    page: number = 1,
    pageSize: number = 10,
    sortBy: string = "score",
    sortDirection: string = "desc"
): Promise<ApiResponse<OwnerEmployeePerformancePagedResponseDto>> {
    const params = new URLSearchParams({
        role: role,
        page: page.toString(),
        pageSize: pageSize.toString(),
        sortBy: sortBy,
        sortDirection: sortDirection
    });

    const apiUrl: string = `/owner/metrics/performance/employee/current?${params.toString()}`;

    var res = apiGet<ApiResponse<OwnerEmployeePerformancePagedResponseDto>>(
        apiUrl, authToken)

    return res;
}